import { useMutation, gql } from '@apollo/client'

interface Data {
  addPartRequest: boolean
}

interface Form {
  rfqId: string
  mpn: string
  description: string
  quantity: number | null
  /** M5 job code (TaskId) the line is opened under (GEA-11818). */
  taskNumber?: string | null
}

const mutation = gql`
  mutation AddPartRequest(
    $rfqId: ID!
    $mpn: String!
    $description: String!
    $quantity: Int!
    $taskNumber: String
  ) {
    addPartRequest(
      rfqId: $rfqId
      mpn: $mpn
      description: $description
      quantity: $quantity
      taskNumber: $taskNumber
    )
  }
`

const useAddPartRequest = () => {
  const [mutate] = useMutation<Data, Form>(mutation)
  return (variables: Form) => mutate({ variables })
}

export default useAddPartRequest
